import React, { useState, useEffect, FC, JSX } from "react";
import { useAgent } from "../../context/AgentContext";
import { CompanyVerificationStatus } from "../../types/api";
import CompanyManagementTable from "../../components/company/CompanyManagementTable";

const AllCompanies: FC = (): JSX.Element => {
  const {
    allCompanies,
    loadingState,
    errorState,
    fetchAllCompanies,
    updateCompanyVerificationStatus,
  } = useAgent();
  const [filterStatus, setFilterStatus] = useState<
    CompanyVerificationStatus | "All"
  >("All");

  // useEffect(() => {
  //   fetchAllCompanies();
  // }, []);

  return (
    <CompanyManagementTable
      companies={allCompanies}
      loading={loadingState.allCompanies}
      error={errorState.allCompanies}
      onRefresh={fetchAllCompanies}
      onUpdateVerificationStatus={updateCompanyVerificationStatus}
      isAdminView={false} // Agent view
      pageTitle="All Companies"
      pageDescription="View and manage all registered companies on the platform"
      showFilter={true}
      filterStatus={filterStatus}
      setFilterStatus={setFilterStatus}
      showReviewGuidelines={false}
      showVerificationHistory={true}
    />
  );
};

export default AllCompanies;
